import { z } from 'zod';

export const CoreBackgroundJobScheduleScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','name','jobType','jobParameters','cronSchedule','enabled','lastJobEnqueuedAt','enqueueNextJobAfter','backgroundJobId','coreIntegrationEsriSettingId']);

export default CoreBackgroundJobScheduleScalarFieldEnumSchema;
